import React from 'react'
import { InsightCardSimple } from '.'
import { Colors } from 'src/components/theme'
import { Typography } from '@mui/material'

type InsightCardNotFoundProps = {
  title: string
  content: string
}

export const InsightCardNotFound: React.FC<InsightCardNotFoundProps> = (props) => {
  const { title, content } = props

  return (
    <InsightCardSimple className="card-simple">
      <Typography variant="title2" color={Colors.textBlack}>
        {title}
      </Typography>
      <Typography variant="text2" color={Colors.textDark}>
        {content}
      </Typography>
    </InsightCardSimple>
  )
}
